/* eslint-disable import/no-anonymous-default-export */
import { StudyForm } from '@wwf/sdk';
import { StudyFormList } from './list/StudyFormList';

export default {
    list: StudyFormList,
    recordRepresentation: (record: StudyForm) =>
        record.title ?? record.id ?? '',
};
